import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
/* eslint-disable compat/compat */
/* eslint-disable @typescript-eslint/no-this-alias */

var unavailableError = new Error('浏览器不支持indexedDB');
export var LogDb = /*#__PURE__*/function () {
  // 记录当前浏览器环境是否兼容

  function LogDb(_temp) {
    var _window$setting, _window$setting$user;
    var _ref = _temp === void 0 ? {} : _temp,
      _ref$preserveDays = _ref.preserveDays,
      preserveDays = _ref$preserveDays === void 0 ? 7 : _ref$preserveDays,
      _ref$removeAmountWhen = _ref.removeAmountWhenFullFilled,
      removeAmountWhenFullFilled = _ref$removeAmountWhen === void 0 ? 10000 : _ref$removeAmountWhen,
      _ref$uid = _ref.uid,
      uid = _ref$uid === void 0 ? (_window$setting = window.setting) === null || _window$setting === void 0 ? void 0 : (_window$setting$user = _window$setting.user) === null || _window$setting$user === void 0 ? void 0 : _window$setting$user.id : _ref$uid;
    _defineProperty(this, "preserveDays", void 0);
    _defineProperty(this, "removeAmountWhenFullFilled", void 0);
    _defineProperty(this, "uid", void 0);
    _defineProperty(this, "db", void 0);
    // indexedDB实例
    _defineProperty(this, "capability", true);
    Object.assign(this, {
      preserveDays: preserveDays,
      removeAmountWhenFullFilled: removeAmountWhenFullFilled,
      uid: uid
    });
    if (this.getEnabled()) {
      this.init();
    }
    window.__logDb__ = this;
  }

  // 获取日志表
  // 从此时起，支持本地日志功能
  // 空闲时执行非紧急任务
  LogDb.executeWhenIdle = function executeWhenIdle(handler) {
    if (window.requestIdleCallback) {
      return window.requestIdleCallback(handler);
    }
    return handler();
  };
  var _proto = LogDb.prototype;
  _proto.getLogTable = function getLogTable(mode) {
    if (mode === void 0) {
      mode = 'readwrite';
    }
    var transaction = this.db.transaction(LogDb.logTableName, mode);
    return transaction.objectStore(LogDb.logTableName);
  }

  // 数据库不存在时，返回异常
  ;
  _proto.rejectWhenDbNotExist =
  /*#__PURE__*/
  function () {
    var _rejectWhenDbNotExist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (this.db) {
              _context.next = 5;
              break;
            }
            _context.next = 3;
            return this.init();
          case 3:
            if (this.db) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", Promise.reject(unavailableError));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function rejectWhenDbNotExist() {
      return _rejectWhenDbNotExist.apply(this, arguments);
    }
    return rejectWhenDbNotExist;
  }() // 获取并操作时间范围内的日志
  ;
  _proto.getLogs = function getLogs(query,
  // 查询条件
  operator // 日志操作函数
  ) {
    if (query === void 0) {
      query = {};
    }
    if (operator === void 0) {
      operator = Function.prototype;
    }
    var logDb = this;
    if (!logDb.capability) return Promise.resolve([]);
    return logDb.rejectWhenDbNotExist().then(function () {
      return new Promise(function (resolve, reject) {
        var logs = [];
        var _query = query,
          _query$index = _query.index,
          index = _query$index === void 0 ? 'createTime' : _query$index,
          _query$condition = _query.condition,
          condition = _query$condition === void 0 ? null : _query$condition;
        var logTable = logDb.getLogTable();
        var request = logTable.index(index).openCursor(condition);
        Object.assign(request, {
          onsuccess: function onsuccess(_ref2) {
            var target = _ref2.target;
            var cursor = target.result;
            if (cursor) {
              logs.push(cursor.value);
              // 执行副作用
              operator({
                db: logDb.db,
                cursor: cursor,
                logTable: logTable
              });
              cursor.continue();
            } else {
              // 遍历完成
              resolve(logs);
            }
          },
          onerror: function onerror(event) {
            reject(event);
          }
        });
      });
    });
  }

  // 创建文件并下载
  ;
  _proto.createFile = function createFile(content, fileName) {
    var link = document.createElement('a');
    var blob = new Blob([content], {
      type: 'text/plain'
    });
    Object.assign(link, {
      href: window.URL.createObjectURL(blob),
      download: fileName
    });
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  _proto.getContent = /*#__PURE__*/function () {
    var _getContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
      var range, section, isRange, query, logs, content, sectionMap, fileName;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            range = _ref3.range, section = _ref3.section;
            isRange = Array.isArray(range); // range为数组，按时间范围+业务线筛选日志，否则按业务线筛选日志
            query = isRange ? {
              index: 'sectionAndCreateTime',
              condition: IDBKeyRange.bound([section, range[0]], [section, range[1]])
            } : {
              index: 'section',
              condition: IDBKeyRange.only(section)
            };
            _context2.next = 5;
            return this.getLogs(query);
          case 5:
            logs = _context2.sent;
            // 为方便查看，最近的日志放最上面
            content = logs.reverse().map(function (_ref4) {
              var content = _ref4.content;
              return content;
            }).join('\n'); // 日志文件命名
            // 业务线日志_用户id_时间戳_log.txt，如果指定时间范围，时间戳为开始时间和结束时间的拼接
            sectionMap = {
              callcenter: '呼叫'
            };
            fileName = (sectionMap[section] || '前端') + "\u65E5\u5FD7_" + (this.uid || 'anonymous') + "_" + (isRange ? range.join('_') : Date.now()) + "_log.txt";
            return _context2.abrupt("return", {
              content: content,
              fileName: fileName
            });
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function getContent(_x) {
      return _getContent.apply(this, arguments);
    }
    return getContent;
  }() // 获取是否开启本地日志
  ;
  _proto.getEnabled = function getEnabled() {
    return window.localStorage.getItem(LogDb.disabledKey) !== '1' && LogDb.available;
  }

  // 设置是否开启本地日志
  ;
  _proto.setEnabled = function setEnabled(enabled) {
    var _this = this;
    return new Promise(function (resolve) {
      if (_this.getEnabled() === enabled) return resolve(_this.db);
      if (enabled) {
        resolve(_this.init());
      } else {
        resolve(_this.destroy());
      }
    }).then(function (db) {
      window.localStorage.setItem(LogDb.disabledKey, String(Number(!enabled)));
      return db;
    });
  }

  // 初始化数据库
  ;
  _proto.init = function init() {
    var logDb = this;
    return new Promise(function (resolve) {
      if (!LogDb.available) {
        console.error('indexedDB初始化失败', unavailableError);
        resolve(undefined);
      }
      if (logDb.db) resolve(logDb.db);
      try {
        var request = window.indexedDB.open('Log', LogDb.version);
        // 更新数据库版本时，先触发onupgradeneeded，再触发onsuccess
        Object.assign(request, {
          onsuccess: function onsuccess(_ref5) {
            var target = _ref5.target;
            logDb.db = target.result;
            // 初始化成功，删除7天前的日志
            LogDb.executeWhenIdle(function () {
              var sevenDaysAgoTimestamp = Date.now() - logDb.preserveDays * 24 * 60 * 60 * 1000;
              logDb.removeLogs({
                query: {
                  index: 'createTime',
                  condition: IDBKeyRange.upperBound(sevenDaysAgoTimestamp)
                }
              });
            });
            resolve(logDb.db);
          },
          onerror: function onerror(event) {
            logDb.db = undefined;
            console.error('indexedDB初始化失败', event);
            resolve(undefined);
          },
          onupgradeneeded: function onupgradeneeded(_ref6) {
            var target = _ref6.target;
            logDb.db = target.result;
            if (!logDb.db.objectStoreNames.contains(LogDb.logTableName)) {
              var logTable = logDb.db.createObjectStore(LogDb.logTableName, {
                autoIncrement: true
              });
              // 创建索引，搜索数据使用
              logTable.createIndex('createTime', 'createTime');
              logTable.createIndex('section', 'section');
              logTable.createIndex('sectionAndCreateTime', ['section', 'createTime']);
            }
          }
        });
      } catch (error) {
        logDb.capability = false;
        logDb.db = undefined;
        console.error('indexedDB初始化失败', error);
        resolve(undefined);
      }
    });
  }

  // 销毁数据库
  ;
  _proto.destroy = function destroy() {
    if (!this.db) return;
    this.db.close();
    this.db = undefined;
    return this.db;
  }

  // 删除满足条件的最早number条日志
  ;
  _proto.removeLogs = function removeLogs(_ref7) {
    var _ref7$query = _ref7.query,
      query = _ref7$query === void 0 ? {} : _ref7$query,
      _ref7$number = _ref7.number,
      number = _ref7$number === void 0 ? Infinity : _ref7$number;
    var counter = 0;
    return this.getLogs(query, function (_ref8) {
      var cursor = _ref8.cursor,
        logTable = _ref8.logTable;
      if (counter < number) {
        logTable.delete(cursor.primaryKey);
        counter++;
      }
    });
  }

  // 新增一条日志
  ;
  _proto.addLog = function addLog(data) {
    if (!data.createTime) data.createTime = Date.now();
    var logDb = this;
    LogDb.executeWhenIdle(function () {
      return !logDb.capability ? Promise.resolve(data) : logDb.rejectWhenDbNotExist().then(function () {
        return new Promise(function (resolve, reject) {
          var logTable = logDb.getLogTable('readwrite');
          var request = logTable.add(data);
          Object.assign(request, {
            onsuccess: function onsuccess() {
              resolve(data);
            },
            onerror: function onerror(event) {
              if (event.target.error.name === 'QuotaExceededError') {
                // 储存空间已满
                // 删除最早的10000条数据后，再次添加日志
                resolve(logDb.removeLogs({
                  number: logDb.removeAmountWhenFullFilled
                }).then(function () {
                  return logDb.addLog(data);
                }));
              } else {
                reject(event);
              }
            }
          });
        });
      });
    });
  }

  // 导出日志
  ;
  _proto.exportLogs =
  /*#__PURE__*/
  function () {
    var _exportLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref9) {
      var range, section, _yield$this$getConten, content, fileName;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            range = _ref9.range, section = _ref9.section;
            if (this.getEnabled()) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return", Promise.reject(unavailableError));
          case 3:
            _context3.next = 5;
            return this.getContent({
              range: range,
              section: section
            });
          case 5:
            _yield$this$getConten = _context3.sent;
            content = _yield$this$getConten.content;
            fileName = _yield$this$getConten.fileName;
            this.createFile(content, fileName);
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function exportLogs(_x2) {
      return _exportLogs.apply(this, arguments);
    }
    return exportLogs;
  }() // 输出blob
  ;
  _proto.getBlob =
  /*#__PURE__*/
  function () {
    var _getBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref10) {
      var range, section, _yield$this$getConten2, content;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            range = _ref10.range, section = _ref10.section;
            if (this.getEnabled()) {
              _context4.next = 3;
              break;
            }
            return _context4.abrupt("return", Promise.reject(unavailableError));
          case 3:
            _context4.next = 5;
            return this.getContent({
              range: range,
              section: section
            });
          case 5:
            _yield$this$getConten2 = _context4.sent;
            content = _yield$this$getConten2.content;
            return _context4.abrupt("return", new Blob([content], {
              type: 'text/plain'
            }));
          case 8:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function getBlob(_x3) {
      return _getBlob.apply(this, arguments);
    }
    return getBlob;
  }();
  return LogDb;
}();
_defineProperty(LogDb, "version", 1);
// 数据库版本号
// Safari浏览器不支持在iframe中使用IndexedDB
_defineProperty(LogDb, "available", Boolean(window.indexedDB && window.localStorage));
_defineProperty(LogDb, "logTableName", 'log');
_defineProperty(LogDb, "disabledKey", 'YSF-LOCALE-LOG-DISABLED');
_defineProperty(LogDb, "availableDate", new Date(2023, 11, 1, 0, 0, 0, 0));
export var getLogDb = function getLogDb(props) {
  if (window.__logDb__) return window.__logDb__;
  return new LogDb(props);
};